/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Mod7_TitleInputs */

const es_landing_mod7_title = /** @type {(inputs: Landing_Mod7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquila tu barco privado, ahora que es legal`)
};

const gl_landing_mod7_title = /** @type {(inputs: Landing_Mod7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aluga o teu barco privado, agora que é legal`)
};

const en_landing_mod7_title = /** @type {(inputs: Landing_Mod7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rent out your private boat — now legal`)
};

/**
* | output |
* | --- |
* | "Rent out your private boat — now legal" |
*
* @param {Landing_Mod7_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_mod7_title = /** @type {((inputs?: Landing_Mod7_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Mod7_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_mod7_title(inputs)
	if (locale === "en") return en_landing_mod7_title(inputs)
	return es_landing_mod7_title(inputs)
});